import {Text, Link} from "@gs-ux-uitoolkit-react/text";
import React, {useState, useEffect} from "react";
import {useSignInContext} from "../context/SignInContextProvider";

interface FormValue {
}

export function InvalidLink() {

    return (
        <div className="flex flex-col items-stretch gap-6 w-full">
            <Text typography="textTitle02" data-qa-comp="invalid-link-title">
                The link provided is invalid or has expired.
            </Text>
        </div>
    );
}